import React from 'react'
import { Card, Table } from 'antd'
import { EmailSystemStatus } from '../interfaces/interfaces'
import { activeRequestsColumns } from '../columns'
import { EmptyState } from '../styles'

interface ActiveRequestsProps {
  status: EmailSystemStatus | null
}

export const ActiveRequests: React.FC<ActiveRequestsProps> = ({ status }) => {
  return (
    <Card title="Активные запросы" style={{ marginBottom: 16 }}>
      {status?.activeRequests.length ? (
        <Table
          dataSource={status.activeRequests}
          columns={activeRequestsColumns}
          rowKey="id"
          pagination={false}
          size="small"
        />
      ) : (
        <EmptyState>Нет активных запросов</EmptyState>
      )}
    </Card>
  )
}

